import React, { Component } from 'react'

export default class Legislative extends Component {
    render() {
        return (
            <div>
                <h5>Legislative</h5>
            </div>
        )
    }
}
